import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FrameType_BINARY_getInstance9h62j6ssxfdm as FrameType_BINARY_getInstance,
  FrameType_TEXT_getInstance13rnlbf2papgb as FrameType_TEXT_getInstance,
  FrameType_CLOSE_getInstanceyjt6b53yjpbv as FrameType_CLOSE_getInstance,
  FrameType_PING_getInstance2m9eh67nmjf4o as FrameType_PING_getInstance,
  FrameType_PONG_getInstance34ya51qooxkd7 as FrameType_PONG_getInstance,
} from './FrameType.mjs';
import { NonDisposableHandle_instance32d73uqknj6a6 as NonDisposableHandle_instance } from './FrameCommon.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  writeText19qfzm98fbm4l as writeText,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { validateSize23lir9ygeqvey as validateSize } from './ControlFrames.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.s5h(fin, data, rsv1, rsv2, rsv3);
      }
      static s5h(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.t5h(fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static u5h(fin, data) {
        return this.s5h(fin, data, false, false, false);
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.c5i(fin, data, rsv1, rsv2, rsv3);
      }
      static c5i(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.t5h(fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static d5i(fin, data) {
        return this.c5i(fin, data, false, false, false);
      }
      static e5i(text) {
        return this.d5i(true, toByteArray(text));
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var CloseClass;
function Close() {
  if (CloseClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.f5i(data);
      }
      static f5i(data) {
        return this.t5h(true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
      static o5f(reason) {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        var builder = new (Buffer())();
        builder.r4j(reason.u5d_1);
        writeText(builder, reason.v5d_1);
        return this.g5i(builder);
      }
      static g5i(packet) {
        return this.f5i(readByteArray(packet));
      }
      static h5i() {
        return this.f5i(Companion_getInstance().f5g_1);
      }
    }
    initMetadataForClass($, 'Close', $.h5i);
    CloseClass = $;
  }
  return CloseClass;
}
var PingClass;
function Ping() {
  if (PingClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.q5g(data);
      }
      static q5g(data) {
        return this.t5h(true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
    }
    initMetadataForClass($, 'Ping');
    PingClass = $;
  }
  return PingClass;
}
var PongClass;
function Pong() {
  if (PongClass === VOID) {
    class $ extends Frame() {
      constructor(data, disposableHandle) {
        return new.target.e5g(data, disposableHandle);
      }
      static e5g(data, disposableHandle) {
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        return this.t5h(true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
      }
    }
    initMetadataForClass($, 'Pong');
    PongClass = $;
  }
  return PongClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.f5g_1 = new Int8Array(0);
      }
      g5g(fin, frameType, data, rsv1, rsv2, rsv3) {
        var tmp;
        switch (frameType.w1_1) {
          case 1:
            tmp = Binary().s5h(fin, data, rsv1, rsv2, rsv3);
            break;
          case 0:
            tmp = Text().c5i(fin, data, rsv1, rsv2, rsv3);
            break;
          case 2:
            tmp = Close().f5i(data);
            break;
          case 3:
            tmp = Ping().q5g(data);
            break;
          case 4:
            tmp = Pong().e5g(data, NonDisposableHandle_instance);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      static t5h(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        var $this = createThis(this);
        $this.d5e_1 = fin;
        $this.e5e_1 = frameType;
        $this.f5e_1 = data;
        $this.g5e_1 = disposableHandle;
        $this.h5e_1 = rsv1;
        $this.i5e_1 = rsv2;
        $this.j5e_1 = rsv3;
        validateSize($this);
        return $this;
      }
      toString() {
        return 'Frame ' + this.e5e_1.toString() + ' (fin=' + this.d5e_1 + ', buffer len = ' + this.f5e_1.length + ')';
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3acdrc353k3ou,
  Binary as Binary3tlzyfojm51s4,
  Close as Close3tx65evcwi73t,
  Ping as Ping3nta6l7sdq1r9,
  Pong as Pong3m3cas9hmc9ec,
  Text as Text3e6ukp9joohql,
};
//endregion

//# sourceMappingURL=Frame.nonJvm.mjs.map
